import { defineStore } from 'pinia'
import { userInfo } from "@/api"
import { showConfirmDialog } from "vant"
import router from '@/router'
interface UserInfo {
  [key: string]: any
}

export const useMainStore = defineStore('main', {
  state: () => ({
    token: '',
    loginInfo: {} as Record<string, any>,
    userInfo: {} as UserInfo,
    service: "",
    service2: "",
    isOtcTc: false,
    sysMessage: false,
    trialBalance: false,
    remark: false,
    is_collect: 0,//是否收藏
    rate:0,//全局汇率
  }),
  actions: {
    setToken(token: string) {
      this.token = token
    },
    setLoginInfo(data: object) {
      this.loginInfo = data
    },
    setUserInfo(data: string | Record<string, any>, val?: any) {
      if (typeof data === 'string') {
        this.userInfo[data] = val
      } else {
        this.userInfo = { ...data }
      }
    },
    setService(url: string) {
      this.service = url
    },
    setService2(url: string) {
      this.service2 = url
    },
    setIsOtcTc(val: any) {
      this.isOtcTc = val
    },
    setSysMessage(val: any) {
      this.sysMessage = val
    },
    setTrialBalance(val: any) {
      this.trialBalance = val
    },
    setRemark(val: any) {
      this.remark = val
    },
    setIs_collect(val: any) {
      this.is_collect = val
    },
    setRate(val: any) {
      this.rate = val
    },

    // 获取用户信息 
    getUserInfo(): Promise<any> {
      return userInfo().then((res: any) => {
        if (res.code === 200) {
          this.userInfo = res.data
          return res.data // 返回数据给调用方
        } else {
          return Promise.reject(res)
        }
      })
    },
    getIsRealName(t:any) {
      // const router = useRouter()
      // console.log(router);
      if (this.userInfo.is_realname == 0) {
        showConfirmDialog({
          title: t('store.a1'),
          confirmButtonColor: "#2969FF",
          confirmButtonText: t('store.a2'),
          cancelButtonText: t('store.a3'),
          // showCancelButton: false,
          message: t('store.a4'),
        }).then(() => {
          router.push('/realNameAuthentication')
        })
        return true
      }
      if (this.userInfo.is_realname == 2) {
        showConfirmDialog({
          title: t('store.a1'),
          confirmButtonColor: "#2969FF",
          confirmButtonText: t('store.a5'),
          cancelButtonText: t('store.a3'),
          // showCancelButton: false,
          message: t('store.a6'),
        }).then(() => {
          router.push('/realNameAuthentication')
        })
        return true
      }
    },
    // 退出清空
    removeStore() {
      this.token = ''
      this.loginInfo = {}
      this.userInfo = {}
      this.service = ''
      this.isOtcTc = false
      this.sysMessage = false
      this.trialBalance = false
      this.remark = false
      // 清除 localStorage 中持久化的数据
      localStorage.removeItem('custom-main-key-store')
    }
  },
  persist: {
    enabled: true,
    key: 'custom-main-key-store',
    storage: localStorage,
    pick: ['token', 'loginInfo', 'userInfo', 'service', 'service2', 'sysMessage', 'is_collect','rate']
  }
})
